export default [
  {
    label: '基础数据',
    width: 300,
    fixed:'left',
    child: [
      {label:'总新增', prop: 'users',width: 100,},
      {label:'推广合计', prop: 'cost', width: 100,},
      {label:'新增单价', prop: 'ecpi', width: 100,},
    ]
  },
  {
    label: '30日预估',
    fixed: true,
    child: [
      {label:'LTV', prop: 'p30_ltv'},
      {label:'回收周期', prop: 'p30_return_day', width: 100},
      {label:'生命周期', prop: 'p30_lt', width: 100},
      {label:'ROI', prop: 'p30_roi'},
    ]
  },
  {
    label: '23日预估',
    child: [
      {label:'LTV', prop: 'p23_ltv'},
      {label:'回收周期', prop: 'p23_return_day', width: 100},
      {label:'生命周期', prop: 'p23_lt', width: 100},
      {label:'ROI', prop: 'p23_roi'},
    ]
  },
  {
    label: '16日预估',
    child: [
      {label:'LTV', prop: 'p16_ltv'},
      { label: '回收周期', prop: 'p16_return_day', width: 100 },
      {label:'生命周期', prop: 'p16_lt', width: 100},
      {label:'ROI', prop: 'p16_roi'},
    ]
  },
  {
    label: '9日预估',
    child: [
      {label:'LTV', prop: 'p9_ltv'},
      { label: '回收周期', prop: 'p9_return_day', width: 100 },
      {label:'生命周期', prop: 'p9_lt', width: 100},
      {label:'ROI', prop: 'p9_roi'},
    ]
  },
  {
    label: '同期群累计收入',
    child: [
      {label:'Day2', prop: 'day2', width: 100 },
      {label:'Day3', prop: 'day3', width: 100 },
      {label:'Day4', prop: 'day4', width: 100 },
      {label:'Day5', prop: 'day5', width: 100 },
      {label:'Day6', prop: 'day6', width: 100 },
      {label:'Day7', prop: 'day7', width: 100 },
      {label:'Day8', prop: 'day8', width: 100 },
    ]
  },
]